import { useQuery } from "@tanstack/react-query";
import { useAdminApplication, useAdminSession } from "../../app/providers";
import { getDashboardMetric } from "./api";

export const dashboardKeys = {
  detail: (sessionEpoch: number, date: string) => (
    ["admin", sessionEpoch, "dashboard", "detail", date] as const
  ),
};

export function useDashboardMetric(date: string) {
  const { apiClient } = useAdminApplication();
  const session = useAdminSession();
  return useQuery({
    queryKey: dashboardKeys.detail(session.sessionEpoch, date),
    queryFn: ({ signal }) => getDashboardMetric(apiClient, date, signal),
    staleTime: 0,
    refetchInterval: false,
  });
}
